import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IWorkspaceModules } from '../../pages/settings/dashboards/dashboards.interface';

@Injectable({ providedIn: 'root' })
export class WorkspaceModuleService {
  private readonly translate = inject(TranslateService);

  public readonly moduleNames: Record<keyof IWorkspaceModules, string> = {
    actionTracker: 'Action Tracker',
    assetTracker: 'Assets Tracker',
    digitalForms: 'Digital Forms',
    laborTracker: 'Labor Tracker',
    oeeTracker: 'OEE Tracker',
    scheduler: 'Scheduler',
    stationTracker: 'Station Tracker',
    utilityWidgets: this.translate.instant('general.utility'),
  };
}
